import { EngraveSide } from 'modules/configurator/Provider'
import { CustomizableEngraveOption } from '_app/graphql/generated/graphql'
import { SelectedEngraveOption } from '_app/types/product'

export function engraveOptionName(option?: CustomizableEngraveOption) {
  if (!option?.value) return ''

  return `engrave_options.${option?.value?.pendant_idx}.${option?.value?.placement}.${option?.value?.code}`
}

export const engravingFileName = (
  option: SelectedEngraveOption | EngraveSide | undefined
) => {
  if (typeof option?.file !== 'string') {
    return ''
  }

  const fileName = option.file.split('/').pop()
  const [alt] = fileName?.match(/[\w]+/) || []

  return alt || ''
}
